import React from "react";
import {
  Box,
  Heading,
  Text,
  Stack,
  HStack,
  Divider,
  SimpleGrid,
  Badge,
  Center,
} from "@chakra-ui/react";
import { Grid, GridItem } from "@chakra-ui/react";

const leftColumn = [
  {
    title: "Basisbehandelingen",
    items: [
      { name: "Gelaatsbehandeling", price: "€60,00" },
      { name: "Acné behandeling", price: "€60,00" },
      { name: "Oogmassage", price: "€20,00" },
      { name: "Lichaamsbehandelingen", price: "€70,00" },
      { name: "Lichaamsmassage (enkel vrouwen)", price: "€70,00" },
      { name: "Bindweefselmassage", price: "€70,00" },
      { name: "Anti-cellulitis", price: "€60,00" },
      { name: "Plaatselijke afslanking", price: "€60,00" },
      { name: "Figuurcorrectie", price: "€60,00" },
      { name: "Hydrafacial behandeling", price: "€60,00" },
      { name: "Carbon Laser Peeling", price: "€60,00" },
      { name: "Microneeding Derma pen", price: "€60,00" },
      { name: "Verwijdering pigmentvlekken", price: "€60,00" },
      { name: "Verwijdering litteken", price: "€60,00" },
      { name: "Verwijdering microblading wenkbrauwen", price: "€40,00" },
    ],
  },
  {
    title: "Cavitatie behandeling",
    subtitle: "Kies een optie",
    items: [
      { name: "Buik", price: "€40,00" },
      { name: "Lovehandles", price: "€40,00" },
      { name: "Hals", price: "€40,00" },
      { name: "Bovenarmen", price: "€80,00" },
      { name: "Bovenbenen", price: "€80,00" },
    ],
  },
  {
    title: "Plasma pen",
    subtitle: "Kies een optie",
    items: [
      { name: "Rond de ogen", price: "€100,00" },
      { name: "Beide oogleden", price: "€100,00" },
      { name: "Rond de mond", price: "€100,00" },
      { name: "Volledig gezicht", price: "€250,00" },
    ],
  },
];

const rightColumn = [
  {
    title: "Laserontharing",
    subtitle: "Prijs per zone (per beurt)",
    badge: "5 + 2 gratis",
    note: "Kies per zone max. 7 beurten (alle beurten na 5 zijn gratis).",
    items: [
      { name: "Gelaat", price: "€55,00" },
      { name: "Bovenlip", price: "€15,00" },
      { name: "Onder ogen", price: "€30,00" },
      { name: "Wangen", price: "€20,00" },
      { name: "Kin", price: "€5,00" },
      { name: "Hals", price: "€20,00" },
      { name: "Nek", price: "€20,00" },
      { name: "Wenkbrauwen", price: "€15,00" },
      { name: "Oksels", price: "€35,00" },
      { name: "Handen", price: "€20,00" },
      { name: "Onderarmen", price: "€70,00" },
      { name: "Bovenarmen", price: "€80,00" },
      { name: "Armen", price: "€110,00" },
      { name: "Schouders", price: "€75,00" },
      { name: "Rug", price: "€150,00" },
      { name: "Onderbenen", price: "€150,00" },
      { name: "Bovenbenen", price: "€155,00" },
      { name: "Volledig benen", price: "€240,00" },
      { name: "Voeten", price: "€20,00" },
      { name: "Volledig lichaam", price: "€250,00" },
      { name: "Volledig bikini (enkel vrouwen)", price: "€75,00" },
      { name: "Bikinilijn (enkel vrouwen)", price: "€40,00" },
      { name: "Neus", price: "€5,00" },
      { name: "Tussen wenkbrauwen", price: "€5,00" },
    ],
  },
];

const bottomCentered = {
  title: "Verwijdering tatoeage",
  subtitle: "Prijs op basis van lengte",
  note: "€5,00 per centimeter.",
  items: [{ name: "Tatoeage verwijderen", price: "€5,00 / cm" }],
};

const PriceCard = ({ group }) => {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="xl"
      p={{ base: 4, md: 5 }}
      bg="white"
      shadow="sm"
    >
      <HStack justify="space-between" align="start" mb={2}>
        <Box>
          <Heading size="md">{group.title}</Heading>
          {group.subtitle && (
            <Text fontSize="sm" color="gray.600" mt={1}>
              {group.subtitle}
            </Text>
          )}
        </Box>

        {group.badge && (
          <Badge colorScheme="pink" variant="subtle" mt={1}>
            {group.badge}
          </Badge>
        )}
      </HStack>

      {group.note && (
        <Text fontSize="sm" color="gray.600" mb={3}>
          {group.note}
        </Text>
      )}

      <Stack spacing={2}>
        {group.items.map((item, idx) => (
          <Box key={idx}>
            <HStack justify="space-between" align="center">
              <Text fontSize="md">{item.name}</Text>
              <Text fontSize="md" fontWeight="semibold">
                {item.price}
              </Text>
            </HStack>
            {idx !== group.items.length - 1 && <Divider mt={2} />}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

const PriceList = () => {
  return (
    <Box>
      <Heading size="lg" mb={2}>
        <Center>Prijslijst</Center>
      </Heading>
      <Center>
      <Text color="gray.600" mb={6}>
        Hieronder vind je een overzicht van onze behandelingen en richtprijzen.
      </Text>
    </Center>
      <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6}>
  {/* Links: basis + cavitatie + plasma onder elkaar */}
  <GridItem>
    <Stack spacing={6}>
      {leftColumn.map((group, idx) => (
        <PriceCard key={idx} group={group} />
      ))}
    </Stack>
  </GridItem>

  {/* Rechts: laser (lange lijst) */}
  <GridItem pb={{ base: 0, md: 12 }}>
  <Stack spacing={6}>
    {rightColumn.map((group, idx) => (
      <PriceCard key={idx} group={group} />
    ))}
  </Stack>
</GridItem>


  {/* Onderaan: tatoeage gecentreerd, over 2 kolommen */}
  <GridItem colSpan={{ base: 1, md: 2 }}>
    <Box display="flex" justifyContent="center">
      <Box width={{ base: "100%", md: "620px" }}>
        <PriceCard group={bottomCentered} />
      </Box>
    </Box>
  </GridItem>
</Grid>


      <Text fontSize="sm" color="gray.500" mt={6}>
        * Prijzen kunnen variëren afhankelijk van intake/advies en persoonlijke situatie.
      </Text>
    </Box>
  );
};

export default PriceList;
